module.exports = __webpack_public_path__ + "assets/img/Earlytrade-Social-Static-Ad.f6da1dd4.webp";